import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetEcshopAccountsService } from "@/features/accounts/ecshop/services/get-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useGetEcshopAccountStates } from "@/features/accounts/ecshop/hooks/use-get-accounts-states";
import { useContext } from "react";


export const useGetEcshopAccount = () => {
  const {
    institutionType,
    setInstitutionType,
    //ecshopAccountId,
    //setEcshopAccountId,
    ecshopAccounts,
    setEcshopAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useGetEcshopAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getEcshopAccountsService = new GetEcshopAccountsService();

  // その他連携口座一覧取得
  const getEcshopAccounts = async (
    accountGroupId: string,
    ecshopAccountId?: string,
    excludeUnselected?: boolean,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const resEcshopAccounts = await getEcshopAccountsService.getEcshopAccounts({
        account_group_id: accountGroupId,
        ...(ecshopAccountId !== undefined && { ecshop_account_id: ecshopAccountId }),
        ...(excludeUnselected !== undefined && { exclude_unselected: excludeUnselected }),
      });
      // 成功時の処理
      setEcshopAccounts(resEcshopAccounts);
      return resEcshopAccounts;
    } catch (error) {
      // エラーハンドリング
      console.log("getEcshopAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    //ecshopAccountId,
    //setEcshopAccountId,
    institutionType,
    setInstitutionType,
    ecshopAccounts,
    setEcshopAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
    getEcshopAccounts: errorHandledAsync(getEcshopAccounts, setError),
  };
};
